import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import * as storageActions from 'store/amwell/storage/actions';
import * as visitContextActions from 'store/amwell/visitContext/actions';
import * as insuranceActions from '../insurance/actions';
import * as actions from './actions';
import { Consumer } from '../../consumer/types';
import { RESET_AMWELL_ACTIVITY } from '../actions';

export type InformationState = Readonly<{
  data: Nullable<Consumer>;
  insuranceStatus: string | null;
  loading: boolean;
  error: Nullable<Error>;
}>;

export const informationInitialState: InformationState = {
  data: null,
  insuranceStatus: null,
  loading: false,
  error: null
};

/**
 * Active Consumer Reducer
 * @desc Could be primary consumer or dependent
 */

export const informationReducer = createReducer(informationInitialState, {
  [actions.UPDATE_CONSUMER]: state => {
    state.loading = true;
    state.error = null;
  },
  [actions.UPDATE_CONSUMER_FAIL]: (state, action) => {
    state.error = action.error;
    state.loading = false;
  },
  [actions.UPDATE_CONSUMER_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.loading = false;
  },
  [insuranceActions.UPDATE_INSURANCE_SUBSCRIPTION_SUCCESS]: (state, action) => {
    state.data = action.payload;
  },
  [insuranceActions.REMOVE_INSURANCE_SUBSCRIPTION_SUCCESS]: (state, action) => {
    state.data = action.payload;
  },
  [insuranceActions.SET_INSURANCE_STATUS]: (state, action) => {
    state.insuranceStatus = action.payload;
  },
  [visitContextActions.CREATE_VISIT_CONTEXT_WITH_APPOINTMENT_SUCCESS]: (state, action) => {
    state.data = action.payload.activeConsumer;
  },
  // Web Amwell Session Restore
  [storageActions.GET_STORAGE_SUCCESS]: (state, action) => {
    state.data = action.payload.activeConsumer;
  },
  [RESET_AMWELL_ACTIVITY]: () => informationInitialState
});
